import { render } from "./PoemHeader.vue?vue&type=template&id=34b055c3"
import script from "./PoemHeader.vue?vue&type=script&lang=js"
export * from "./PoemHeader.vue?vue&type=script&lang=js"

import "./PoemHeader.vue?vue&type=style&index=0&id=34b055c3&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__